export class RateRenewal {
  public AccountNumber?: string;
  public SaId?: string;
  public PremiseId?: string;
  public RenewalFlag?: boolean;
}
